<template>
  <header>
    <div class="header-left"><h2>Slate CodeX</h2><h3>-ALPHA</h3></div><div class = "header-right"><p v-if="authStore.loading">Loading...</p>
    <p v-else>
    {{ authStore.username }}
      <span v-if="authStore.admin">(Admin)</span>
    </p>
    <button v-if="authStore.active" @click="authStore.logout">Logout</button>
    <button v-else @click="authStore.login">Login (by invite only)</button></div>
  </header>
<!-- Sign in Screen -->
<div class="unauth-overlay" v-if="!authStore.active && collectionPath !== 'public'"><!--Grey out the background-->
        <div class="unauth" v-if="!authStore.active && collectionPath !== 'public'"><!--Login Window-->
          <h2 style="text-align:center">
            Something great is under development. <br/>Stop by later to check it out.
          </h2>
          <div class="google-button">
            <button @click="authStore.login">Sign in with Google - by invite only</button>
          </div>
          <div class="microsoft-button">
  <button @click="authStore.loginWithMicrosoft">Sign in with Microsoft - by invite only</button>
</div>

        </div>
      </div>
  <div>
    <router-view v-if="authStore.active || collectionPath === 'public'"></router-view>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useAuthStore } from "@/stores/authStore";
import { useDbStore } from '@/stores/dbStore';

const authStore = useAuthStore();
const dbStore = useDbStore();
authStore.initializeAuth();

const { collectionPath } = storeToRefs(dbStore);

</script>


<style>

/****** Base Styles ******/
body {
    margin: 0;
    font-family: Consolas, "Courier New", monospace;
    background-color: #1e1e1e;
    color: #d4d4d4;
  }
  
  #app {
    padding: 10px;
  }
    
  main p {
    margin-bottom: 5px;
  }
  
  main select {
    padding: 5px;
    background-color: #333;
    color: #d4d4d4;
    border: 1px solid #555;
    border-radius: 4px;
    margin-top: 0px;
  }
  
  /****** Button Styles ******/
  
  .button-container {
    margin: 5px 0;
  }
  
  button {
    background-color: #00669e; /* Default blue background */
    color: white;
    border: none;
    padding: 3px 3px;
    margin: 3px 3px 3px 3px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.3s ease, cursor 0.3s ease; /* Smooth transitions */
  }
  
  button:hover {
    background-color: #01395c; /* Darker blue on hover */
  }
  
  /****** Save Button Styles ******/
  .save-button.unchanged {
    background-color: #4caf50; /* Green for "saved" state */
    cursor: not-allowed; /* Indicate the button is disabled */
    pointer-events: none; /* Disable clicks */
  }
  
  .save-button.unchanged:hover {
    background-color: #4caf50; /* Keep green even on hover */
  }
  
  .save-button.changed {
    background-color: #007acc; /* Default blue for "changed" state */
    cursor: pointer; /* Enable clicking */
  }
  
  .save-button.changed:hover {
    background-color: #005f99; /* Darker blue on hover */
  }
  
  /* The full-screen overlay that darkens the background */
  .unauth-overlay {
    position: fixed;           /* Ensure the overlay covers the whole screen */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);  /* Semi-transparent dark background */
    display: flex;             /* Enable Flexbox for centering the inner div */
    align-items: center;       /* Center vertically */
    justify-content: center;   /* Center horizontally */
    z-index: 1000;             /* Place the overlay on top of other elements */
  }
  
  /* The centered unauth div that auto-resizes with content */
  .unauth {
    background: #1e1e1e;
    color: #c5c6c7;   
    padding: 20px;             /* Add some padding for spacing */
    border-radius: 10px;       /* Rounded corners */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);  /* Subtle drop shadow */
    max-width: 90%;            /* Responsive width: no more than 90% of the viewport */
    margin: 20px;              /* Optional: margin to ensure it's not flush against the viewport */
  }
  
  .google-button {
    display: flex;
      justify-content: center;
      align-items: center; /* Ensures vertical centering if the div has a height */
      margin: auto;
    }
  
    .google-button button {
      background: #3a3a3a;
      border: none;
      padding: 8px 12px;
      color: #fff;
      cursor: pointer;
      border-radius: 4px;
      
    }
    .google-button button:hover {
      background: #505050;
    }

.microsoft-button {
    display: flex;
      justify-content: center;
      align-items: center; /* Ensures vertical centering if the div has a height */
      margin: auto;
    }

    .microsoft-button button {
      background: #3a3a3a;
      border: none;
      padding: 8px 12px;
      color: #fff;
      cursor: pointer;
      border-radius: 4px;

    }
    .microsoft-button button:hover {
      background: #505050;
    }

/****** Header Styles ******/
header {
  display: flex; 
  justify-content: space-between; /* Ensures left and right justification */
  align-items: center;
  margin: 0px;
}

.header-left {
  display: flex;
  }

.header-right {
  display: flex;
  align-items: center;
  gap: 0.5rem; /* Adjust spacing between buttons and p elements */
}

header h2 {
  color: #007acc;
  margin: 0px;
  }

header h3 {
  color: #007acc;
  margin: 0px;
  align-self: flex-end;
}

header p, header button {
  margin: 0px;
}

</style>